<template>
 <transition name="scale">
    <div
      class="customModal fillForm"
      v-show="visible"
      >
      <Modal title="赠送扣减积分" @cancel="addIntegralVisible = false" :footer="null" :visible="addIntegralVisible" width="400px">
        <AppForm
          v-if="addIntegralVisible"
          ref="form"
          formStyle="default"
          :fields="formFields"
          :rules="rules"
          @cancel="addIntegralVisible = false"
          @submit="addIntegralSubmit"
        />
      </Modal>
			<BasicTable
				border
				hasOperate
        :pageSize="pageSize"
        :currentPage="pageIndex"
				@pageChange="pageChange"
        :total="total"
        customClass="table"
				:tableData="tableData"
				:treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
				:columns="columns" >
			<template slot="tableOpeate">
				积分记录表&emsp;
        <AppButton size="mini" type="primary" plain @click="close" ><i class="fa fa-share fa-2" aria-hidden="true"></i>返回用户列表</AppButton>
        <AppButton size="mini" type="primary" plain @click="openAddIntegral">积分调整</AppButton>
			</template>
			</BasicTable>
    </div>
  </transition>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { UserService } from '../../service/user.service';
import moment from 'moment';
const searchFields = [
  { name: '批号名称', key: 'name', type: 'input' },
];
const columns = [
  { name: '变动时间', key: 'change_time' },
  { name: '变更描述', key: 'brand_logo' },
  { name: '订单编号', key: 'order_sn' },
  { name: '用户积分', key: 'pay_points' },
  { name: '变更备注', key: 'desc' },
];
  export default {
    name: 'userIntegral',
    components: { Modal },
    data() {
      return {
        visible: false,
        searchFields,
        tableData: [],
        columns,
        addIntegralVisible: false,
        userData: {},
        rules: {
          pay_points: [{ required: true, message: '积分数量不能为空'}],
          desc: [{ required: true, message: '赠送积分描述不能为空'}],
        },
        formFields: [
          { type: 'number', key: 'pay_points', label: '积分数量', span: 24 },
          { type: 'textarea', key: 'desc', label: '赠送积分描述', span: 24 },
        ],
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      }
    },
    methods: {
      async open(data) {
        this.pageIndex = 1;
        this.userData = data;
        this.getList();
        this.visible = true;
      },
      async getList() {
        const res = await UserService.integralList(this.userData.user_id, this.pageIndex, this.pageSize);
        res.list.forEach(item => {
          item.change_time = moment().utc(item.change_time).format('YYYY-MM-DD HH:mm:ss');
        })
        this.total = res.totalRow;
        this.tableData = res.list;
      },
      pageChange(index) {
        this.pageIndex = index;
        this.getList();
      },
      close() {
        this.visible = false;
      },
      openAddIntegral() {
        this.addIntegralVisible = true;
      },
      async addIntegralSubmit(data) {
        if(data) {
          data.user_id = this.userData.user_id;
          await UserService.giveIntegral(data);
          this.open(this.userData);
          this.addIntegralVisible = false;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.title {
	padding: 0;
	margin: 0;
}
</style>
